import Collection from '../../utils/Collection';

import { CLEAR_TUTOR_DATA } from '../../actions/tutor';

import {
  FETCH_TIMESLOT_STATUSES_BY_TUTOR_SENT,
  FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED,
  FETCH_TIMESLOT_STATUSES_BY_TUTOR_FAILED,
} from '../../actions/timeslot';

import {
  BOOK_SUCCEEDED,
  CANCEL_BOOKING_SUCCEEDED,
} from '../../actions/booking';

const initialState = {
  loading: false,
  slotStatuses: [],
};

export default function tutorTimeslotReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_TUTOR_DATA:
      return initialState;
    case FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        slotStatuses: Collection.reset(state.slotStatuses, payload.slot_status),
      };
    case FETCH_TIMESLOT_STATUSES_BY_TUTOR_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TIMESLOT_STATUSES_BY_TUTOR_SENT:
      return {
        ...state,
        loading: true,
      };
    case BOOK_SUCCEEDED:
    case CANCEL_BOOKING_SUCCEEDED:
      return {
        ...state,
        slotStatuses: Collection.updateMany(
          state.slotStatuses,
          payload.changedStatuses,
        ),
      };
    default:
      return state;
  }
}
